import { createContext, useContext } from 'react';

interface BannerContextValue {
  isBannerShown: boolean;
}

const BannerContext = createContext<BannerContextValue>({
  isBannerShown: false,
});

export const useBanner = () => useContext(BannerContext);

export default BannerContext;
